import { BsBuildings, BsStack } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import errorImage from "../../assets/images/error.png";
import loader from "../../assets/images/loader.gif";
import nodata from "../../assets/images/nodata.png";
import noimg from "../../assets/images/noimg.webp";
import PagesHeading from "../common/PagesHeading";
import Pagination from "../common/Pagination";
import PatrocinosCards from "../common/PatrocinosCards";
import { ProfessionalsFilter } from "./ProfessionalsFilter";

const ProfessionalsList = ({
  professionals,
  userCount,
  loading,
  error,
  topRef,
  currentPage,
  handleFilterChange,
  navigateToProfessionalDetail,
  handlePageChange,
}) => {
  return (
    <>
      <PagesHeading
        title={"Professionals"}
        subtitle={`${userCount} registered professionals`}
        description={
          "Find construction sector professionals in the specialized directory Balarch. Find architects, engineers, contractors, renderers, and other professionals in the sector. Let's build community."
        }
      />
      <PatrocinosCards />
      <div
        className="grid grid-cols-1 gap-10 lg:grid-cols-8 mt-20 mb-10"
        ref={topRef}
      >
        <div className="lg:col-span-2">
          <ProfessionalsFilter onFilterChange={handleFilterChange} />
        </div>

        <div className="lg:col-span-6">
          <div className="mb-5">
            <div className="flex  items-center">
              <div className="text-gray-700 text-md capitalize font-semibold pl-4">
                {professionals.length} professionals found
              </div>
            </div>
          </div>
          <hr />

          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <img src={loader} alt="loader" />
            </div>
          ) : error ? (
            <div className="flex justify-center items-center h-screen">
              <img src={errorImage} alt="error" />
            </div>
          ) : professionals.length === 0 ? (
            <div className="flex justify-center items-center h-screen">
              <img src={nodata} alt="no data" />
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4 mt-5 sm:grid-cols-2 lg:grid-cols-1">
              {professionals.map((user, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:flex-row hover:shadow-md transition-shadow"
                >
                  <img
                    className="rounded-full mx-5 my-5 w-40 h-40 shadow-lg"
               
                    src={user.ProfilePicture || noimg}
                    alt="Not available"
                  />
                  <div className="flex flex-col justify-between p-4 leading-normal">
                    <div className="flex items-center">
                      <div className="text-xl border-r font-semibold border-gray-400 pr-4">
                        {user.Name}
                      </div>
                      <div className="text-gray-500 font-semibold pl-4">
                        {user.ProfessionPositionName}
                      </div>
                    </div>

                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      {user.ShortBio &&
                        user.ShortBio.split(" ").slice(0, 20).join(" ")}{" "}
                      {user.ShortBio && user.ShortBio.split(" ").length > 20
                        ? "..."
                        : ""}
                    </p>

                    <div className="grid grid-cols-3 gap-2 mt-5 sm:grid-cols-2 lg:grid-cols-3">
                      <div className="flex items-center gap-4 text-sm">
                        <CiLocationOn className="text-lg" />
                        <span>{user?.Country?.countryName}</span>
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        <BsStack className="text-lg" />
                        <span>{user?.ProjectList?.length || 0} projects</span>
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        <BsBuildings className="text-lg" />
                        <span>{user.Industry}</span>
                      </div>
                    </div>
                    <div className="flex w-full md:w-auto gap-4 my-5 mt-5">
                      <button
                        className="text-white bg-gray-800 hover:bg-neutral-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium text-sm px-3 py-1.5 me-2 mb-2"
                        onClick={() =>
                          navigateToProfessionalDetail(user.UserId)
                        }
                      >
                        View profile
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {userCount > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={userCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProfessionalsList;
